/**
 * Guardia simple para rutas del dashboard de usuario.
 *
 * Comportamiento actual:
 * - si no hay sesión, redirige a login,
 * - si la suscripción reporta inactiva/cancelada, envía a reactivación,
 * - en caso contrario deja pasar al componente solicitado.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { checkSubscriptionStatus } from "../utils/checkSubscriptionStatus"; // Utilidad para verificar la membresía

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useAuth();

  // Aquí verificamos si el usuario tiene una membresía activa
  const subscriptionStatus = checkSubscriptionStatus(currentUser?.uid);

  if (!currentUser) {
    return <Navigate to="/login" />;
  } else if (
    subscriptionStatus === "inactive" ||
    subscriptionStatus === "canceled"
  ) {
    return <Navigate to="/reactivate" />;
  } else {
    return <Component {...rest} />;
  }
};

export default PrivateRoute;
